export class IdDetailsModel{

    
    public name:string;
    public idNo:string;
    public idType:string;
    public countryOfIssuance:string;
    constructor(){
        
    }
}